import React from 'react';

// import components
import CategoryIconCards from 'components/partials/category-icon-cards';

// import types
import { CategoryIconCardProps } from 'components/partials/parts/category-icon-card';

// import hooks
import { getLinkById } from 'hooks/use-generate-site-link';

// Import Images
import { ReactComponent as IconLink } from "img/icons/icon-link.svg";
import { ReactComponent as IconAllowancesSmoking } from "img/icons/icon-allowances-smoking.svg";
import { ReactComponent as IconBabyCareBottle } from "img/icons/icon-baby-care-bottle.svg";
import { ReactComponent as IconBabyCareTrolley1 } from "img/icons/icon-baby-care-trolley-1.svg";
import { ReactComponent as IconBaggageQuestion } from "img/icons/icon-baggage-question.svg";
import { ReactComponent as IconBus2 } from "img/icons/icon-bus-2.svg";
import { ReactComponent as IconCarRideHailing } from "img/icons/icon-car-ride-hailing.svg";
import { ReactComponent as IconDisabilityWheelcharDirectionForward } from "img/icons/icon-disability-wheelchair-direction-forward.svg";
import { ReactComponent as IconDiscountDollarDash } from "img/icons/icon-discount-dollar-dash.svg";
import { ReactComponent as IconInformationCircle } from "img/icons/icon-information-circle.svg";
import { ReactComponent as IconMatchesFire } from "img/icons/icon-matches-fire.svg";
import { ReactComponent as IconMedicalCross } from "img/icons/icon-medical-cross.svg";
import { ReactComponent as IconParkingP } from "img/icons/icon-parking-p.svg";
import { ReactComponent as IconSignBadgeBadge } from "img/icons/icon-sign-badge-badge.svg";
import { ReactComponent as IconSingleNeutralSearch } from "img/icons/icon-single-neutral-search.svg";
import { ReactComponent as IconTicket } from "img/icons/icon-ticket.svg";
import { ReactComponent as IconToiletSeat } from "img/icons/icon-toilet-seat.svg";
import { ReactComponent as IconTruckRv } from "img/icons/icon-truck-rv.svg";
import { ReactComponent as IconWashingHand } from "img/icons/icon-washing-hand.svg";
import { ReactComponent as IconGate } from "img/icons/icon-gate.svg";
import { ReactComponent as IconRecycle } from "img/icons/icon-recycle.svg";
import { ReactComponent as IconSensoryInclusive } from "img/icons/icon-sensory-inclusive.svg";

// Import helpers
import { getLinkDataFromDato } from "helpers/get-link-data";

const ServicesRowBuilder: React.FC<{ servicesRowData?: Queries.ServicesRowBlockFragment }> = ({ servicesRowData }) => {

    if (!servicesRowData) return null;

    const cards: CategoryIconCardProps[] = servicesRowData.services?.map((service): CategoryIconCardProps | undefined => {

        if (!service) return undefined;

        let serviceIcon = getServiceIcon(service.iconName ?? '');

        let serviceUrl = getLinkById(service.id) || '#';

        return {
            title: service.title ?? '',
            icon: serviceIcon,
            url: serviceUrl
        };

    }).filter((card): card is CategoryIconCardProps => card !== undefined) || [];

    // if no cards, return null
    if (cards.length === 0) return null;

    const linkData = getLinkDataFromDato(servicesRowData.link?.link);

    return (
        <CategoryIconCards
            introHeadlineProps={{
                headline: servicesRowData.heading ?? '',
                buttonProps: linkData ? {
                    buttonText: linkData?.label || 'Error: Missing label',
                    buttonUrl: linkData?.url || '#',
                    target: linkData?.target || '_self',
                } : undefined
            }}
            cards={cards}
        />
    );
};

export default ServicesRowBuilder;

const getServiceIcon = (iconName: string): React.FC<React.SVGProps<SVGElement>> => {
    switch (iconName) {
        case "allowances-smoking":
            return IconAllowancesSmoking;
        case "baby-care-bottle":
            return IconBabyCareBottle;
        case "baby-care-trolley-1":
            return IconBabyCareTrolley1;
        case "baggage-question":
            return IconBaggageQuestion;
        case "bus-2":
            return IconBus2;
        case "car-ride-hailing":
            return IconCarRideHailing;
        case "disability-wheelchair-direction-forward":
            return IconDisabilityWheelcharDirectionForward;
        case "discount-dollar-dash":
            return IconDiscountDollarDash;
        case "information-circle":
            return IconInformationCircle;
        case "matches-fire":
            return IconMatchesFire;
        case "medical-cross":
            return IconMedicalCross;
        case "parking-p":
            return IconParkingP;
        case "sign-badge-badge":
            return IconSignBadgeBadge;
        case "single-neutral-search":
            return IconSingleNeutralSearch;
        case "ticket":
            return IconTicket;
        case "toilet-seat":
            return IconToiletSeat;
        case "truck-rv":
            return IconTruckRv;
        case "washing-hand":
            return IconWashingHand;
        case "entrance-gate":
            return IconGate;
        case "recycling":
            return IconRecycle;
        case "sensory-inclusive":
            return IconSensoryInclusive;
        default:
            return IconLink;
    }
}